import { Component } from '@angular/core';

@Component({
  selector: 'app-pagination-showcase',
  templateUrl: './pagination-showcase.component.html',
  styleUrls: ['./pagination-showcase.component.scss']
})
export class PaginationShowcaseComponent {
  // Basic demo — 50 items, 10 per page
  basicPage: number = 1;
  basicTotalItems: number = 50;
  basicItemsPerPage: number = 10;

  // Large dataset demo — 1000 items, 20 per page, starts mid-range
  largePage: number = 15;
  largeTotalItems: number = 1000;
  largeItemsPerPage: number = 20;

  // Small dataset — fits on one page window
  smallPage: number = 2;
  smallTotalItems: number = 25;
  smallItemsPerPage: number = 5;

  // Single page edge case
  singlePage: number = 1;
  singleTotalItems: number = 8;
  singleItemsPerPage: number = 10;

  onBasicPageChange(page: number): void {
    this.basicPage = page;
  }

  onLargePageChange(page: number): void {
    this.largePage = page;
  }

  onSmallPageChange(page: number): void {
    this.smallPage = page;
  }

  onSinglePageChange(page: number): void {
    this.singlePage = page;
  }
}
